import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { CustomLink } from '../../CustomLink';

import {
  LayoutContainer,
  ImageBlock,
  ContentBlock,
  Header,
  FormContainer,
  Footer,
  FooterLink
} from './styled';
import CloseIcon from '../../../public/static/images/close-modal.svg';
import { STATIC_PAGES } from '../../../utils/helpers/constants';
import Icon from '../../Icon';
import { decodeReturnToUrl } from '../../../utils/helpers/url';
import { Notification } from '../../ui/Notification';
import { useNotification } from '../../ui/Notification/hooks/useNotification';
import { clearEnteredEmailValueToLS } from '../helpers/emailHandler';
import { StyledLogoIcon } from '../../HamburgerMenu/styled';

interface Props {
  children: ReactNode;
}

export const AuthByEmailContainer = ({ children }: Props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const {
    message,
    isClosing,
    isTargetPage,
    startToShowNotif,
    closeNotification
  } = useNotification(router.asPath);

  const agreement = t('authentication.agreement');
  const rules = t('authentication.rules');

  const handleClose = () => {
    const returnTo = router.query.return_to;
    const returnLink =
      returnTo && returnTo !== 'undefined'
        ? decodeReturnToUrl(router.query.return_to)
        : '/';
    clearEnteredEmailValueToLS();
    window.location.href = returnLink;
  };

  return (
    <LayoutContainer>
      <ImageBlock />
      <ContentBlock>
        <Header>
          <CustomLink href="/" data-cy="logo" aria-label="Go to home">
            <StyledLogoIcon
              data-cy="header-menu-logo"
              data-stat="header-menu-logo"
              alt="logo"
              width={85}
              height={19}
            />
          </CustomLink>

          <Icon
            indent={false}
            IconComponent={CloseIcon}
            width={15}
            height={15}
            onClick={handleClose}
            dataCypress="close-auth-page"
          />
        </Header>
        <FormContainer>{children}</FormContainer>
        <Footer tag="body_2" data-cy="auth-page-footer">
          <Trans
            i18nKey="authentication.confirmation"
            values={{ agreement, rules }}
          >
            <FooterLink href={STATIC_PAGES.TERMS}>{{ agreement }}</FooterLink>
            <FooterLink href={STATIC_PAGES.RULES}>{{ rules }}</FooterLink>
          </Trans>
        </Footer>
      </ContentBlock>
      {message && isTargetPage && startToShowNotif <= 1 && (
        <Notification
          message={message.text}
          type={message.type}
          isClosing={isClosing}
          closeNotification={closeNotification}
        />
      )}
    </LayoutContainer>
  );
};
